module.exports = __webpack_public_path__ + "img/enterprise-img.b13d04a3.png";